<section id="option-details" class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <div class="row">
        <div class="columns small-12">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div
            class="panel rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>

          <div class="panel rs-panel-big clearfix">
            <div class="small-only-text-center">
              <div
                class="panel rs-inline-block rs-wd-s6 rs-wd-m10 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>

            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
            ></div>
            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
            ></div>
            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
            ></div>
            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>

            <div class="small-only-text-center">
              <div
                class="panel rs-inline-block rs-wd-s15 rs-wd-m20 rs-h-s3 rs-h-m5 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
            <div class="rs-flex-row rs-flex-middle rs-flex-dir-col-small-only">
              <div class="rs-flex-columns">
                <div
                  class="panel rs-wd-s15 rs-h-s4 rs-h-m6 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
              <div class="rs-flex-columns rs-flex-grow">
                <div
                  class="panel rs-wd-s20 rs-wd-s25 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                ></div>
                <div
                  class="panel rs-wd-s20 rs-wd-s25 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
            </div>
            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
            ></div>
            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
            ></div>
            <div
              class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
